export const timeRanges = ['24h', '3d', '7d', '30d'] as const;

export type TimeRange = (typeof timeRanges)[number];
export type ChartParam = 'answer' | 'abandon' | 'ai_resolution' | 'agent_handoff' | 'asa';
export type ChartSmsParam = 'ai_resolution' | 'agent_handoff' | 'asa';

export type DashboardFilters = {
  time_range?: TimeRange;
  company_name?: string | undefined;
  start_time?: string;
  end_time?: string;
  time_zone?: string;
};

export type CallMetricsChartParams = {
  time_range?: TimeRange;
  chart_params?: ChartParam;
  start_time?: string;
  end_time?: string;
  time_zone?: string;
  company_name?: string;
};

export type SmsMetricsChartParams = {
  time_range?: TimeRange;
  chart_params?: ChartSmsParam;
  start_time?: string;
  end_time?: string;
  time_zone?: string;
  company_name?: string;
};

export type TrendingTopicsExportParams = {
  start_time?: string;
  end_time?: string;
  time_range?: TimeRange;
};

export type CallMetricsChart = {
  chart: AiPerformanceChartPoint[];
};

export type SmsMetricsChart = {
  chart: AiPerformanceChartPoint[];
};

type Metric = {
  value: number;
  change: number;
};

type PercentageMetric = {
  current_percent: number;
} & Metric;

type CallMetricChartPoint = {
  date: string;
  ai: number;
  agent: number;
};

export type CallMetrics = {
  inbound_calls: Metric;
  answer: PercentageMetric;
  abandon: PercentageMetric;
  ai_resolution: PercentageMetric;
  agent_handoff: PercentageMetric;
  asa: Metric;
  chart: CallMetricChartPoint[];
};

export type SmsMetrics = {
  inbound_sms: Metric;
  answer: PercentageMetric;
  abandon: PercentageMetric;
  ai_resolution: PercentageMetric;
  agent_handoff: PercentageMetric;
  asa: Metric;
  chart: CallMetricChartPoint[];
};

export type Insight = {
  [key: string]: number | null;
};

export type InsightLanguageDistribution = {
  [key: string]: {
    count: number;
    language_flag_url: string | null;
  };
};

export type InsightOverallSatisfaction = {
  ai: number | null;
  agent: number | null;
  overall: number | null;
  responses: number | null;
  change: number;
};

export type Insights = {
  trending_topics: Insight;
  language_distribution: InsightLanguageDistribution;
  overall_satisfaction: InsightOverallSatisfaction;
};

export type AiPerformance = {
  number_of_responses: AiPerformanceMetric;
  number_of_unanswered: AiPerformanceMetric;
  average_ai_handling_time: AiPerformanceMetric;
  average_response_time: AiPerformanceMetric;
  chart: {
    number_of_responses: AiPerformanceChartPoint[];
    unanswered_chart: AiPerformanceChartPoint[];
    average_ai_handling_time: AiPerformanceChartPoint[];
    average_response_time_chart: AiPerformanceChartPoint[];
  };
};

export type AiPerformanceMetric = {
  value: number;
  change: number;
};

export type AiPerformanceChartPoint = {
  date: string;
  value: number | string;
};
